/* eslint-disable max-lines-per-function */
import React from 'react';
export const CallsToActionThreeColumnsPreview = (): JSX.Element => (
    <svg xmlns="http://www.w3.org/2000/svg" width="287" height="74" viewBox="0 0 287 74">
        <g data-name="Calls to action: three columns" transform="translate(-831 -2645)">
            <g fill="#fff" transform="translate(831 2645)">
                <rect width="287" height="74" stroke="none" rx="4" />
                <rect width="286" height="73" x="0.5" y="0.5" fill="none" rx="3.5" />
            </g>
            <g data-name="Button - Website Primary Button" transform="translate(868 2669)">
                <rect width="50" height="26" fill="#718096" data-name="Button background" rx="4" />
                <text fill="#fff" fontFamily="Mulish-Regular, Mulish" fontSize="10" transform="translate(10 17)">
                    <tspan x="0" y="0">
                        Button
                    </tspan>
                </text>
            </g>
            <g data-name="Button - Website Primary Button" transform="translate(950 2669)">
                <rect width="50" height="26" fill="#718096" data-name="Button background" rx="4" />
                <text
                    fill="#fff"
                    data-name="Button"
                    fontFamily="Mulish-Regular, Mulish"
                    fontSize="10"
                    transform="translate(10 17)"
                >
                    <tspan x="0" y="0">
                        Button
                    </tspan>
                </text>
            </g>
            <g data-name="Button - Website Primary Button" transform="translate(1032 2669)">
                <rect width="50" height="26" fill="#718096" data-name="Button background" rx="4" />
                <text
                    fill="#fff"
                    data-name="Button"
                    fontFamily="Mulish-Regular, Mulish"
                    fontSize="10"
                    transform="translate(10 17)"
                >
                    <tspan x="0" y="0">
                        Button
                    </tspan>
                </text>
            </g>
        </g>
    </svg>
);
